import $axios from "../api/accessor";
import { $api } from "../api/api";

export const DangerousService = {
  async GetDangerousPackages() {
    let response = await $axios
      .get($api("get_DangerousPackages"), {
       
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
